import React from 'react';
import { toast } from 'react-toastify';
import Success from 'app/notifications/success';

export default function notifySuccess(content, options = {}) {
  toast.success(<Success>{content}</Success>, options);
}
